import ReactDOM from 'react-dom'
import 'bootstrap/dist/css/bootstrap.min.css'
import './assets/css/styles.css'
import App from './components/App'

const rootElement = document.getElementById('root')
ReactDOM.render(<App />, rootElement)
